export default {
  email_confirm: {
    header: {
      title: 'ยืนยันที่อยู่อีเมลเสร็จสมบูรณ์',
    },
    completed: {
      // section_one: '',
      // section_two: '',
      // section_three: '',
      // section_four: '',
    },
    expired: {
      // section_one: '',
      // section_two: '',
      // section_three: '',
    },
    btn: {
      // service_top: '',
      // login: '',
      register: 'ลงทะเบียน',
      rating_url: 'https://asuene.com/rating/en',
    },
  },
}
